<template>
  <div class="show-user fl">
    <div class="slider fl">
      <!--轮播图-->
      <slideShow :imgData="imgOptionsA"></slideShow>
    </div>
    <div class="work">
      <div class="title">工作动态</div>
      <div class="content">
        <div class="list" v-for="(item, index) in workData" :key="index">
          <div class="dot"></div>
          <div class="img" v-if="item.coverFileUrl">
            <el-image
              style="width: 70px; height: 70px"
              :src="item.coverFileUrl"
              :fit="'cover'"
            >
            </el-image>
          </div>
          <div class="text">
            <div
              class="text-one"
              :title="item.title.length > 35 ? item.text : ''"
            >
              <a @click="handleOp(item)">{{ item.title }}</a>
              <span v-if="!item.coverFileUrl" class="time" style="float: right">
                [{{ item.publishedBy }}] {{ item.timeBefore }}
              </span>
            </div>
            <span v-if="item.coverFileUrl" class="time" style="float: right"
              >[{{ item.publishedBy }}] {{ item.timeBefore }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <el-link
      :underline="false"
      type="info"
      class="notice-more"
      @click="handleViewAll()"
      >更多 ></el-link
    >
  </div>
</template>

<script>
import slideShow from "@/app/shop/components/slideShow.vue";
import { qryPostersList, qryWorkDynamicsList } from "@/app/shop/api/shopping";
import Cookies from "js-cookie";
import moment from "moment";
export default {
  name: "showUser",
  components: {
    slideShow
  },
  props: {
    imgData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dividerList: [],
      imgOptionsA: [],
      baseUrl: this.$addUrlPerFix(process.env.VUE_APP_BASE_URL),
      purchaseAgentId: "",
      supplyAgentId: "",
      workData: []
    };
  },
  mounted() {},
  activated() {
    this.init();
  },
  deactivated() {
    this.dividerList = [];
  },
  methods: {
    init() {
      // 查询宣传海报
      qryWorkDynamicsList({
        area: 0,
        pageSize: 5,
        pageNo: 1,
        title: "",
        author: "",
        publishedBy: "",
        updateTimeMore: "",
        updateTimeLess: ""
      }).then(res => {
        if (res.data.code === "0") {
          this.imgOptionsA = res.data.data.rows;
        }
      });
      qryWorkDynamicsList({
        area: 1,
        pageSize: 5,
        pageNo: 1,
        title: "",
        author: "",
        publishedBy: "",
        updateTimeMore: "",
        updateTimeLess: ""
      }).then(res => {
        if (res.data.code === "0") {
          this.workData = res.data.data.rows;
          this.workData.forEach((item, index) => {
            if (item.title.length > 35) {
              console.log(item.title.length, index, "length");
              item.content = item.title.substring(0, 35) + "...";
            } else {
              item.content = item.title;
            }
          });
        }
      });
    },
    handleOp(row) {
      this.$router.push({
        path: "/announcementDetail",
        query: {
          id: row.id,
          source: "0",
          publishedBy: row.publishedBy
        }
      });
    },
    handleHelp(index) {
      // let item = this.imgData[index] ? this.imgData[index] : {};
      // if (item.otherUrl) {
      //   //点击量
      //   updateHits({
      //     publicityContentId: item.publicityContentId
      //   });
      //   window.open(item.otherUrl, "_blank");
      // }
      //  采购子平台
      if (index === 0) {
        if (Cookies.get("access_token")) {
          this.purchaseAgentId = JSON.parse(
            localStorage.getItem("agentIdList")
          ).purchaseAgentId;
          let href = "";
          if (this.baseUrl.indexOf("dev01") != -1) {
            href = `https://dev01-scpma.iccec.cn/index?a=${this.purchaseAgentId}`;
          } else if (this.baseUrl.indexOf("test01") != -1) {
            href = `https://test01-scpma.iccec.cn/index?a=${this.purchaseAgentId}`;
          } else if (this.baseUrl.indexOf("uat01") != -1) {
            href = `https://uat01-scpma.iccec.cn/index?a=${this.purchaseAgentId}`;
          } else {
            href = `https://scpma.iccec.cn/index?a=${this.purchaseAgentId}`;
          }
          window.open(href, "_blank");
        } else {
          window.location.href =
            this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
            "?redirectUrl=" +
            this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
        }
      }
      // 供应子平台
      if (index === 1) {
        if (Cookies.get("access_token")) {
          this.supplyAgentId = JSON.parse(
            localStorage.getItem("agentIdList")
          ).supplyAgentId;
          let href = "";
          if (this.baseUrl.indexOf("dev01") != -1) {
            href = `https://dev01-smp.iccec.cn/?a=${this.supplyAgentId}`;
          } else if (this.baseUrl.indexOf("test01") != -1) {
            // href = `https://test01-smp.iccec.cn/contractManagement/materialContractApproval/approvalList?a=${this.supplyAgentId}`;
            href = `https://test01-smp.iccec.cn/?a=${this.supplyAgentId}`;
          } else if (this.baseUrl.indexOf("uat01") != -1) {
            href = `https://uat01-smp.iccec.cn/?a=${this.supplyAgentId}`;
          } else {
            href = `https://smp.iccec.cn/?a=${this.supplyAgentId}`;
          }
          window.open(href, "_blank");
        } else {
          window.location.href =
            this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
            "?redirectUrl=" +
            this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
        }
      }
      if (index === 2) {
        this.$router.push({
          path: "/operationManual",
          query: {}
        });
        console.log(url, "url");
      }
      if (index === 3) {
        this.$router.push({
          path: "/question",
          query: {}
        });
      }
    },
    //更多 >
    handleViewAll() {
      this.$router.push({
        path: "/announcementsList",
        query: {
          source: "0"
        }
      });
    },
    //退出
    handleExit() {
      localStorage.clear();
      window.location.href =
        this.$addUrlPerFix("mla.iccec.cn/apis/mla/users/signup/doLogout") +
        "?ACCESS_TOKEN=" +
        Cookies.get("access_token") +
        "&redirectUrl=" +
        encodeURIComponent(window.location.href);
    },
    //登录
    handleLogin() {
      window.location.href =
        this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
        "?redirectUrl=" +
        this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
    }
  },
  computed: {
    loginInfo() {
      return this.$store.getters.getLoginInfo;
    },
    headLogo() {
      if (this.loginInfo.iConLink) {
        return this.loginInfo.iConLink;
      } else {
        return require("@/basa/assets/images/headLogo.png");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.clearfix-item {
  display: flex;
}
.show-user {
  width: 1160px;
  height: 438px;
  display: flex;
  background: #ffffff;
  padding: 20px 0 0 22px;
  position: relative;
  .work {
    // width: 365px;
    margin-left: 20px;
    .title {
      font-weight: bold;
      font-size: 20px;
      color: #222222;
      line-height: 30px;
      text-align: left;
      font-style: normal;
      margin-bottom: 10px;
    }
    .content {
      .list {
        display: flex;
        margin-bottom: 15px;
        position: relative;
        padding: 0 9px 0 16px;
        .dot {
          position: absolute;
          left: 0px;
          width: 6px; /* 可以根据需要调整大小 */
          height: 6px; /* 可以根据需要调整大小 */
          background: #b6b6b6;
          border-radius: 50%; /* 圆形属性 */
          display: inline-block; /* 使其可以与其他元素水平排列 */
          margin-top: 8px;
          margin-right: 6px;
        }
        .img {
          margin-right: 7px;
        }
        .text {
          width: 100%;
          height: 100%;
          font-size: 18px;
          // font-weight: 600;
          color: #4a4a4a;
          line-height: 25px;
          letter-spacing: 1px;
          .text-one {
            height: 50px;
            display: -webkit-box;
            text-overflow: ellipsis;
            overflow: hidden;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            // &:hover {
            //   cursor: pointer;
            // }
          }
          .time {
            font-size: 13px;
            color: #c6c6c6;
            line-height: 25px;
            text-align: right;
            font-style: normal;
            margin-right: 13px;
          }
        }
      }
    }
  }
  .notice-more {
    position: absolute;
    right: 10px;
    bottom: 20px;
    margin-right: 13px;
    font-weight: 400;
    font-size: 13px;
    &:hover {
      color: #0089ef;
    }
  }
}
.divider-header {
  padding: 10px 0 16px 0;
  font-size: 12px;
  line-height: 18px;
  .titleIcon {
    display: inline-block;
    .icon-ccui-bell-o {
      margin-right: 5px;
      color: #ff954e;
    }
    .icon-ccui-bell-o + span {
      color: #4a4a4a;
    }
  }
  .titleIcon + a {
    color: #9b9b9b;
  }
}
.dividerList {
  width: 240px;
  font-size: 13px;
  color: #4a4a4a;
  letter-spacing: 0;
  font-weight: 400;
  li {
    line-height: 18px;
    font-weight: 400;
    margin-bottom: 4px;
  }
}

.fl {
  float: left;
}
.icon-trumpet {
  width: 15.02px;
  height: 14px;
  padding-right: 7px;
}

.help-center-img {
  margin: 0 8px 10px;
}
</style>
